import { render, staticRenderFns } from "./CompetitionRules.vue?vue&type=template&id=467a1d84&scoped=true&lang=html&"
import script from "./CompetitionRules.vue?vue&type=script&lang=js&"
export * from "./CompetitionRules.vue?vue&type=script&lang=js&"
import style0 from "./CompetitionRules.vue?vue&type=style&index=0&id=467a1d84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467a1d84",
  null
  
)

export default component.exports